import { useFlags } from '@mint-lib/routing-context';

export const useMdmPlatformsV2FF = () => {
  const ff = useFlags('@mint/arm', ['importHubMdmPlatformsV2']);

  return ff.importHubMdmPlatformsV2.enabled;
};
